module.exports = __webpack_public_path__ + "static/media/figuretext-1.459e6427.png";